/**
 * Party cell — two-line render of `{partyName}` + optional sub-text (the
 * prototype's `<div className="muted" style={{fontSize:12}}>` note line).
 *
 * Kept narrow on purpose: the ledger table reuses this for the Контрагент
 * column, and InvoiceDetail will reuse it for payer/payee labels. The
 * sub-line is left to the call-site to localise — sometimes it's `note`
 * (a free-text string), sometimes a `t(...)` lookup; passing it as a prop
 * keeps this component agnostic of the source.
 */

import type { ReactNode } from 'react'

interface PartyCellProps {
  name: ReactNode
  sub?: ReactNode
}

export function PartyCell({ name, sub }: PartyCellProps) {
  return (
    <div className='flex flex-col leading-tight'>
      <span className='text-sm text-(--text-default)'>{name}</span>
      {sub ? <span className='text-xs text-(--text-secondary)'>{sub}</span> : null}
    </div>
  )
}
